import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { ART, BRAND, INTRO, FOUNDER_ROLE, FOUNDER_STORY } from "../data/experiences";

const FounderProfile = () => (
  <section id="anas-khan" className="editorial-section bg-white" data-testid="anas-khan-profile">
    <div className="editorial-container narrative-layout">
      <div>
        <p className="editorial-label mb-5">THE FOUNDER</p>
        <h2 className="editorial-heading" data-testid="about-founder-name">Anas Khan</h2>
        <p className="mt-5 text-sm leading-relaxed text-maroon max-w-xs" data-testid="about-founder-role">{FOUNDER_ROLE}</p>
        <figure className="founder-portrait-frame" data-testid="about-founder-portrait-figure">
          <img src={ART.founder} alt="Anas Khan, founder of Unzip Delhi, overlooking the city at night" width="1500" height="2000" loading="lazy" className="artwork-image" data-testid="about-founder-portrait" />
        </figure>
        <p lang="ur" dir="rtl" className="urdu-wordmark" data-testid="about-urdu-calligraphy">{BRAND.urdu}</p>
      </div>
      <div className="editorial-prose" data-testid="about-founder-story">
        {FOUNDER_STORY.slice(0, 3).map((text, i) => <p key={i} data-testid={`about-founder-paragraph-${i}`}>{text}</p>)}
      </div>
    </div>
  </section>
);

export default function Founder() {
  return (
    <main data-testid="about-page" className="bg-ivory">
      <header className="editorial-container page-intro">
        <p className="editorial-label mb-6">ABOUT UNZIP DELHI</p>
        <h1 className="font-accent text-4xl sm:text-5xl lg:text-6xl text-maroon max-w-3xl leading-tight" data-testid="about-headline">The People Behind Unzip Delhi</h1>
        <p className="editorial-body mt-7 max-w-2xl" data-testid="about-brand-introduction">{INTRO[5]}</p>
      </header>
      <FounderProfile />
      <section className="editorial-section" data-testid="about-approach-section">
        <div className="editorial-container community-layout">
          <figure>
            <img src={ART.kotla} alt="Historical painting of the remains of Feroz Shah Kotla, Delhi" width="735" height="531" className="artwork-image" loading="lazy" data-testid="about-archive-image" />
            <figcaption className="artwork-caption">Feroz Shah Kotla remains, Delhi. Supplied artwork.</figcaption>
          </figure>
          <div>
            <h2 className="editorial-heading mb-6" data-testid="about-approach-heading">Storytelling rooted in place.</h2>
            <div className="editorial-prose"><p>{INTRO[3]}</p><p>{INTRO[4]}</p></div>
            <div className="mt-8 flex flex-wrap gap-5">
              <Link to="/experiences" className="editorial-button" data-testid="about-experiences-link">Explore Experiences <ArrowRight size={16} /></Link>
              <Link to="/contact" className="editorial-link" data-testid="about-contact-link">Get in touch <ArrowRight size={15} /></Link>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
